const normaliseUser = require('./../../../utils/normalise-user')

/**
 * Retrieves and normalizes a user by their username.
 *
 * @param {object} state - The application state, including data access layer.
 * @param {string} userName - The username of the user to retrieve.
 * @returns {Promise<object>} The normalized user object.
 */
exports.get = async function (state, userName) {
  const userId = `org.couchdb.user:${userName}`
  const user = await state.dal.user.getOne(state, userId)
  return normaliseUser(user)
}
